import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SystemSettingsService } from 'src/app/shared/services/system-settings/system-settings.service';

@Component({
  selector: 'app-licence-check',
  templateUrl: './licence-check.component.html',
  styleUrls: ['./licence-check.component.scss']
})
export class LicenceCheckComponent implements OnInit {
  isRebrandCompany = false;

  rsltType: string = "license";

  title: string = "License";
  staticScreen = true;
  @Output() childTitleEvent = new EventEmitter();

  constructor(private logservice: SystemSettingsService) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.logservice.logDetail = "";
      this.logservice.LogType = "";
      this.logservice.CompanyLogo = "";
      this.logservice.UserName = "";
      this.logservice.isLoggedIn = false;
      this.logservice.isCommonLogo = true;

      if (localStorage.getItem('SystemSettings') != null) {
        localStorage.removeItem('SystemSettings');
        localStorage.clear();
      }

      if (sessionStorage.getItem('SystemSettings') != null) {
        sessionStorage.removeItem('SystemSettings');
        sessionStorage.clear();
      }

      if (localStorage.getItem('Keyword') != null) {
        localStorage.removeItem('Keyword');
        localStorage.clear();
      }

      if (sessionStorage.getItem('Keyword') != null) {
        sessionStorage.removeItem('Keyword');
        sessionStorage.clear();
      }

      this.parentEvent();

    });
  }


  parentEvent() {
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }
}
